import React from 'react';

type CustomButtonType =
  | React.ComponentType<{ triggerCopy: (cb?: () => void) => void }>
  | React.ReactElement;

interface LocalCopyButtonProps {
  text: string;
  customButton?: CustomButtonType;
}

const LocalCopyButton: React.FC<LocalCopyButtonProps> = ({
  text,
  customButton,
}) => {
  const copyToClipboard = () => {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text);
    } else {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  };

  const handleClick = (cb?: () => void) => {
    copyToClipboard();
    if (typeof cb === 'function') cb();
  };

  if (customButton) {
    if (React.isValidElement(customButton)) {
      return <span onClick={() => handleClick()}>{customButton}</span>;
    }
    if (typeof customButton === 'function') {
      const ButtonComp = customButton as React.ComponentType<{
        triggerCopy: (cb?: () => void) => void;
      }>;
      return <ButtonComp triggerCopy={handleClick} />;
    }
  }

  return (
    <button onClick={() => handleClick()} className="local-copy-button">
      Copy
    </button>
  );
};

export default LocalCopyButton;
